(function () {
  'use strict';
  var config = window.auroreCertificateConfig;
  if (!config || !config.variantId) return;
  var busy = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function request(path, payload) {
    return fetch(root + path, {
      method: payload ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: payload ? JSON.stringify(payload) : undefined
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || 'Unable to update your cart. Please try again.');
        return data;
      });
    });
  }
  function isCertificate(item) { return Number(item.variant_id || item.id) === Number(config.variantId); }
  function eligible(item) {
    return !isCertificate(item) && !item.gift_card && item.requires_shipping && !item.parent_relationship;
  }
  function childFor(cart, parentKey) {
    return cart.items.find(function (line) {
      return isCertificate(line) && line.parent_relationship && line.parent_relationship.parent_key === parentKey;
    });
  }
  function escape(value) {
    return String(value).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; });
  }
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:config.currency || 'USD'}).format(cents / 100);
  }
  function optionHtml(item, cart) {
    if (!eligible(item)) return '';
    var child = childFor(cart, item.key);
    var quantity = item.quantity > 1 ? ' (' + item.quantity + ')' : '';
    var priceHtml = escape(money(config.price)) + (item.quantity > 1 ? ' each' : '');
    if (child) {
      var charged = chargedLinePrice(child);
      priceHtml = '<strong>' + escape(money(charged)) + '</strong>';
      if (charged < child.original_line_price) priceHtml += ' <s>' + escape(money(child.original_line_price)) + '</s>';
    }
    return '<div><label class="aur-certificate-option"><input type="checkbox" data-aur-certificate-cart="' + escape(item.key) + '"' + (child ? ' checked' : '') + '><span>' + (child ? 'Lab certificate' + quantity : 'Add a lab certificate') + ' &mdash; <span class="aur-certificate-charge">' + priceHtml + '</span></span></label><div class="aur-certificate-error" role="alert"></div></div>';
  }
  function chargedLinePrice(item) {
    // Ajax final_line_price excludes order-level discounts; total_discount includes them.
    if (typeof item.original_line_price === 'number' && typeof item.total_discount === 'number') {
      return Math.max(0, item.original_line_price - item.total_discount);
    }
    return typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price;
  }
  async function mutate(action) {
    if (busy) throw new Error('Please wait for the current cart update.');
    busy = true;
    document.documentElement.classList.add('aur-certificate-busy');
    try { return await action(); }
    finally { busy = false; document.documentElement.classList.remove('aur-certificate-busy'); }
  }
  async function changeQuantity(key, quantity) {
    return mutate(async function () {
      var before = await request('cart.js');
      var parent = before.items.find(function (line) { return line.key === key; });
      if (!parent) throw new Error('Your cart has changed. Please refresh and try again.');
      var child = childFor(before, key);
      var after = await request('cart/change.js', {id:key,quantity:quantity});
      if (child && quantity > 0) {
        // Shopify can regenerate both keys when a parent line changes.
        var updatedParent = after.items.find(function (line) {
          return line.key === key || (line.variant_id === parent.variant_id && JSON.stringify(line.properties || {}) === JSON.stringify(parent.properties || {}));
        });
        var remaining = updatedParent && childFor(after, updatedParent.key);
        if (!updatedParent || !remaining) throw new Error('Please refresh your cart to check the certificate quantity.');
        if (remaining.quantity !== updatedParent.quantity) {
          try {
            after = await request('cart/change.js', {id:remaining.key,quantity:updatedParent.quantity});
          } catch (error) {
            // Restore the parent quantity if its paid add-on could not be kept in sync.
            await request('cart/change.js', {id:updatedParent.key,quantity:parent.quantity});
            throw error;
          }
        }
      }
      return after;
    });
  }
  async function toggle(key, checked) {
    return mutate(async function () {
      var cart = await request('cart.js');
      var parent = cart.items.find(function (line) { return line.key === key; });
      if (!parent || !eligible(parent)) throw new Error('Your cart has changed. Please refresh and try again.');
      var child = childFor(cart, key);
      if (checked && !child) {
        await request('cart/add.js', {items:[{id:config.variantId,quantity:parent.quantity,parent_line_key:key,properties:{'For':parent.product_title}}]});
      } else if (!checked && child) {
        await request('cart/change.js', {id:child.key,quantity:0});
      }
      return request('cart.js');
    });
  }
  function productPayload(item, include) {
    if (!include) return item;
    var parent = Object.assign({}, item, {id:Number(item.id),properties:Object.assign({},item.properties)});
    // Keep separately configured copies of the same variant attached to their own certificate.
    parent.properties._aurore_cert_group = window.crypto.randomUUID();
    return {items:[parent,{id:config.variantId,quantity:parent.quantity,parent_id:parent.id}]};
  }
  window.AuroreCertificate = {chargedLinePrice:chargedLinePrice,optionHtml:optionHtml,isCertificate:isCertificate,childFor:childFor,changeQuantity:changeQuantity,productPayload:productPayload,toggle:toggle};
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-certificate-open]');
    if (opener) {
      var dialog = document.getElementById(opener.dataset.certificateOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    var close = event.target.closest('[data-certificate-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.aur-certificate-dialog')) {
      var bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  document.addEventListener('click', function (event) {
    if (busy && event.target.closest('a[href*="/checkout"],button[name="checkout"],.aur-qty-btn,.aur-ci-rm')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', async function (event) {
    var input = event.target.closest('[data-aur-certificate-cart]');
    if (!input) return;
    var checked = input.checked;
    var error = input.closest('label').parentElement.querySelector('.aur-certificate-error');
    if (error) error.textContent = '';
    input.disabled = true;
    try {
      var cart = await toggle(input.dataset.aurCertificateCart, checked);
      document.dispatchEvent(new CustomEvent('aurore:certificate-updated', {detail:cart}));
      if (input.closest('#aurLineItems')) window.location.reload();
    } catch (err) {
      input.checked = !checked;
      if (error) error.textContent = err.message;
    } finally { input.disabled = false; }
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('[data-aur-certificate-slot]')) return;
    request('cart.js').then(function (cart) {
      document.querySelectorAll('[data-aur-certificate-slot]').forEach(function (slot) {
        var item = cart.items.find(function (line) { return line.key === slot.dataset.aurCertificateSlot; });
        if (item) slot.innerHTML = optionHtml(item, cart);
      });
    }).catch(function () { /* Do not offer an unverified cart add-on after a failed load. */ });
  });
})();
